import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ParameterFilingDrawer from "./modules/ParameterFilingDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
import { getAction, downloadFile } from '@/api/manage'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'ParameterFilingList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    ParameterFilingDrawer: ParameterFilingDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/parameter/filing',
      pageTitle: '关键参数备案',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      url: {
        delete: '/om/parameter/filing/item'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: 'rownum',
        key: 'rownum',
        width: 60,
        align: 'center',
        customRender: function customRender(text, record) {
          return {
            children: text,
            attrs: {
              rowSpan: record.assetIdrowSpan
            }
          };
        }
      }, {
        dataIndex: 'productName',
        title: '设备仪表',
        key: 'productName',
        align: 'center',
        customRender: function customRender(text, record) {
          console.log('record', record);
          return {
            children: text,
            attrs: {
              rowSpan: record.assetIdrowSpan
            }
          };
        }
      }, {
        dataIndex: 'rangeName',
        colName: 'range_name',
        title: '量程名称',
        align: 'center',
        sorter: false,
        key: 'rangeName',
        customRender: function customRender(text, record) {
          return {
            children: text,
            attrs: {
              rowSpan: record.rangeNamerowSpan
            }
          };
        }
      }, {
        dataIndex: 'rangeValue',
        colName: 'range_value',
        title: '值',
        key: 'rangeValue',
        align: 'center',
        sorter: false,
        customRender: function customRender(text, record) {
          return {
            children: text,
            attrs: {
              rowSpan: record.rangeValuerowSpan
            }
          };
        }
      }, {
        dataIndex: 'keyParameter_dictText',
        colName: 'keyParameter_dictText',
        title: '关键参数',
        key: 'keyParameterDictText',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'maxValue',
        colName: 'max_value',
        title: '最大值',
        key: 'maxValue',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'minValue',
        colName: 'min_value',
        key: 'minValue',
        title: '最小值',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'unitName',
        key: 'unitName',
        colName: 'unitName',
        title: '单位',
        align: 'center',
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    handleEdit: function handleEdit(record) {
      console.log('record', record);
      this.$refs.modalForm.edit(record); //console.log(record)

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    handleAdd: function handleAdd() {
      if (this.queryParam.scope == 1) {
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = '新增：' + this.pageTitle;
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.showTab = true;
        this.$refs.modalForm.showContact = false;
        this.$refs.modalForm.Listvalue = [];
        this.$refs.modalForm.paramData = [];
        this.$refs.modalForm.itemList = [];
        this.$refs.modalForm.selectValue = '';
        this.$refs.modalForm.depName = '';
        this.$refs.modalForm.productName = '';
        this.$refs.modalForm.activeKey = '1';
        this.$refs.modalForm.showInput = true;
      } else {
        this.$notification.warning({
          message: '请选择站点'
        });
      }
    },
    handleRefresh: function handleRefresh() {
      this.initTableData();
    },
    //查看
    // handleDetail(record) {
    //   this.$refs.modalForm.ViewData(record)
    // },
    initTableData: function initTableData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      console.log('params', params);

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          // 数据处理成平铺
          var arr = [];
          res.result.forEach(function (element) {
            if (element.parameterFilingItems.length > 0) {
              element.parameterFilingItems.forEach(function (item) {
                arr.push(_objectSpread(_objectSpread({}, element), item));
              });
            } else {
              arr.push(_objectSpread({}, element));
            }
          });
          _this.dataSource = arr;
          _this.dataSource = _this.createNewArr(_this.dataSource, 'assetId');
          _this.dataSource = _this.createNewArr(_this.dataSource, 'rangeValue');
          _this.dataSource = _this.createNewArr(_this.dataSource, 'rangeName');
          console.log('dataSource', _this.dataSource);
          _this.loadNums++;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    createNewArr: function createNewArr(data, key) {
      // data 需要处理的表格数据 key 就是需要合并单元格的唯一主键，我这里是projectId
      var datas = data.reduce(function (result, item) {
        //首先将key字段作为新数组result取出
        if (result.indexOf(item[key]) < 0) {
          result.push(item[key]);
        }

        return result;
      }, []).reduce(function (result, value, rownum) {
        //将key相同的数据作为新数组取出，并在其内部添加新字段**rowSpan**
        var children = data.filter(function (item) {
          return item[key] === value;
        });
        result = result.concat(children.map(function (item, index) {
          var _objectSpread2;

          return _objectSpread(_objectSpread({}, item), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, key + 'rowSpan', index === 0 ? children.length : 0), _defineProperty(_objectSpread2, key + 'rownum', rownum + 1), _objectSpread2));
        }));
        return result;
      }, []);
      console.log('datas', datas);
      return datas;
    }
  }
};